import { ComponentType } from "react"
import { Navigate, useLocation, Outlet } from "react-router-dom"
import { useAuth } from "../hooks/useAuth"
import { enRules } from "interfaces/IUser"

type IPrivateRoute = {
  component?: ComponentType
  rules: enRules[]
}

export const PrivateRoute = ({ component: RouteComponent, rules: pageRules }: IPrivateRoute) => {
  const {
    user: { isAuthenticated, rules },
  } = useAuth()
  const location = useLocation()
  return !isAuthenticated ? (
    <Navigate to="/login" state={{ from: location }} replace />
  ) : rules.some(rule => pageRules.includes(rule)) || pageRules.length === 0 ? (
    RouteComponent ? (
      <RouteComponent />
    ) : (
      <Outlet />
    )
  ) : (
    <Navigate to="/dashboard" state={{ from: location }} replace />
  )
}
